import React, { useState } from "react";

import { Col } from "antd";
import { RightOutlined } from "@ant-design/icons";

import MobCreditCard from "./MobCreditCard";
import MobDirectCreditCard from "./MobDirectCreditCard";
import {
  mobDirectStatusCheck,
  rupifiStatusCheck,
} from "../../../commonUtils/commonUtils";

const MobCreditWrapper = (props) => {
  const {
    ruipiCheck,
    approved_balance,
    available_balance,
    mobCreditData,
    rupifyData,
  } = props;

  const cardDataRaw = [
    {
      id: 1,
      title: "mobCREDIT by Rupifi",
    },
    {
      id: 2,
      title: "Credit Line",
    },
  ];

  const hideRupifiCard = rupifiStatusCheck.includes(rupifyData?.account_status);
  const hideMobCreditCard = mobDirectStatusCheck.includes(
    mobCreditData?.status
  );

  // Build cardData dynamically
  let cardData = cardDataRaw;

  // Hide Rupifi card (id = 1)
  if (!hideRupifiCard) {
    cardData = cardData.filter((card) => card.id !== 1);
  }

  // Hide MobCredit card (id = 2)
  if (!hideMobCreditCard) {
    cardData = cardData.filter((card) => card.id !== 2);
  }

  const [index, setIndex] = useState(0);

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % cardData.length);
  };

  return (
    <>
      <Col className="d-flex">
        {cardData.length > 0 && (
          <div className="mob-credit-wrapper"
            style={{
              position: "relative",
              width: "360px",
              height: "100px",
            }}
          >
            {cardData.map((card, i) => {
            // calculate relative position from active index
            const position = (i - index + cardData.length) % cardData.length;

            return (
              <div
                key={card.id}
                className="mob-credit-container-fix"
                style={{
                  // width: 320,
                  position: "absolute",
                  top: 0,
                  left: position * 15, // shift each next card slightly right
                  zIndex: cardData.length - position + 1, // active card on top
                  transition: "all 0.5s ease",
                  height: "100%",
                  // width:"100%",
                  color: "white",
                  borderRadius: "8px",
                }}
              >
                {card?.title === "mobCREDIT by Rupifi" ? (
                  <MobCreditCard
                    ruipiCheck={ruipiCheck}
                    approved_balance={approved_balance}
                    available_balance={available_balance}
                  />
                ) : card?.title === "Credit Line" ? (
                  <MobDirectCreditCard
                    primary_status={mobCreditData?.status}
                    approved_balance={mobCreditData?.sanctioned}
                    available_balance={mobCreditData?.available}
                    is_activated={mobCreditData?.is_activated}
                  />
                ) : null}
                {/* Show arrow only on top card */}
                {position === 0 && cardData.length > 1 && (
                  <div
                    onClick={handleNext}
                    style={{
                      position: "absolute",
                      top: "45%",
                      right: -20,
                      transform: "translateY(-50%)",
                      background: "#fff",
                      borderRadius: "50%",
                      width: 36,
                      height: 36,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                    }}
                  >
                    <RightOutlined style={{ color: "#000", fontSize: 16 }} />
                  </div>
                )}
              </div>
            );
          })}
          </div>
        )}
      </Col>
    </>
  );
};

export default MobCreditWrapper;
